import { gql, TypePolicy } from '@apollo/client'

/** Each response is a complete projection, never a page of outstanding actions. */
export const PAYMENT_FOLLOW_UP_TYPE_POLICY: TypePolicy = {
  fields: { outstandingByAction: { merge: false } }
}

const PAYMENT_FOLLOW_UP_FIELDS = gql`
  fragment PaymentFollowUpFields on PaymentFollowUp {
    __typename
    id
    reason
    state
    paymentNumber
    displayReservationNumber
    bookingReference
    crsNumbers
    amount
    currency
    gateway
    gatewayPaymentType
    details
    openedAt
    resolvedAt
    resolvedBy
    resolution
    caseSchemaVersion
    revision
    requiredAction
    amountUnderReview
    amountBasis
    detectionSource
    resolutionOutcome
    projectionContract
    projectionComplete
    outstandingByAction {
      action
      currency
      knownAmount
      hasUnknownAmount
      amountBasis
    }
    evidence {
      paymentStatus
      paymentType
      provider
      providerEvidence
      movement
      refundState
      crsStatus
      pmsStatus
      walletCreditState
    }
  }
`

export const PAYMENT_FOLLOW_UPS_QUERY = gql`
  query PaymentFollowUps(
    $filter: PaymentFollowUpFilter
    $page: Int
    $perPage: Int
  ) {
    paymentFollowUps(filter: $filter, page: $page, perPage: $perPage) {
      items {
        ...PaymentFollowUpFields
      }
      total
      page
      perPage
    }
  }
  ${PAYMENT_FOLLOW_UP_FIELDS}
`

export const RESOLVE_PAYMENT_FOLLOW_UP_MUTATION = gql`
  mutation ResolvePaymentFollowUp(
    $id: String!
    $resolution: String!
    $settlement: PaymentSettlementInput
  ) {
    resolvePaymentFollowUp(
      id: $id
      resolution: $resolution
      settlement: $settlement
    ) {
      ...PaymentFollowUpFields
    }
  }
  ${PAYMENT_FOLLOW_UP_FIELDS}
`
